<template>
<div class="chapter">
<div class="inner_page">
<p class="p3">A todos los hijos pródigos del mundo: sigan tocando.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?09991e2a